/**
 * Decode a JWT payload segment safely: supports **base64url**, **Unicode** in claims, and returns
 * `null` on malformed tokens (no throw).
 *
 * Uses percent-encoding via `decodeURIComponent` so `JSON.parse` does not break on non-ASCII UTF-8
 * sequences in the decoded bytes.
 */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length < 2 || !parts[1]?.length) {
      return null;
    }
    let b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) {
      b64 += '=';
    }
    const binary = atob(b64);
    const json = decodeURIComponent(
      binary
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    const parsed: unknown = JSON.parse(json);
    if (parsed == null || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return null;
    }
    return parsed as Record<string, unknown>;
  } catch {
    return null;
  }
}
